import React, { Component, isValidElement, cloneElement } from "react";
import { Radio } from "antd";

import WeaInput from "../wea-input";
import WeaInputNumber from "../wea-input-number";
import WeaTextarea from "../wea-textarea";
import WeaSelect from "../wea-select";
import WeaBrowser from "../wea-browser";
import WeaDatePicker from "../wea-date-picker";
import WeaTimePicker from "../wea-time-picker";
import WeaTimeRangePicker from "../wea-time-range-picker";
import WeaColorPicker from "../wea-color-picker";
import WeaCheckbox from "../wea-checkbox";
import WeaCascader from "../wea-cascader/index.js";
import WeaError from "../wea-error";
import WeaLocaleProvider from "../wea-locale-provider";
import isFunction from "lodash/isFunction";
import WindowFunc from "../wea-tools/window";

const { formatMultiLang } = WeaLocaleProvider;

export default class TableCell extends Component {
  static displayName = "TableCell";

  componentWillReceiveProps(nextProps) {
    const {
      validate: { pass, validateResult },
      com: { key },
      rowKey,
      record
    } = nextProps;
    if (
      pass === false &&
      key &&
      validateResult &&
      validateResult[key] &&
      validateResult[rowKey] === record[rowKey]
    ) {
      const error = this.refs[`error_${record[rowKey]}_${key}`];
      error && error.showError();
    }
  }

  shouldComponentUpdate(nextProps) {
    return true;
  }

  getBrowerDatas = (record, key) => {
    const replaceDatas = [];
    if (record[`${key}span`] !== void 0) {
      const keys =
        typeof record[key] === "string"
          ? record[key].split(",")
          : [record[key]];
      const values =
        typeof record[`${key}span`] === "string"
          ? record[`${key}span`].split(",")
          : [record[`${key}span`]];
      if (keys.length === values.length) {
        keys.forEach((k, i) => {
          k !== "" &&
            values[i] !== "" &&
            replaceDatas.push({ id: k, name: values[i] });
        });
      }
    }
    return replaceDatas;
  };

  createBrowser = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = this.getBrowerDatas(record, key);
    const { browserConditionParam = {} } = props;
    return (
      <WeaBrowser
        style={{ width: "100%", display: "inline-block" }}
        viewAttr={2}
        layout={WindowFunc.getTop().document.body}
        {...props}
        {...browserConditionParam}
        replaceDatas={v}
        onChange={(ids, names, browserDatas) =>
          this.props.onEdit({
            record,
            index,
            key,
            value: ids,
            names,
            browserDatas,
            type
          })
        }
      />
    );
  };

  createCascader = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key];
    return (
      <WeaCascader
        viewAttr={2}
        {...props}
        values={v}
        onChange={value =>
          this.props.onEdit({ record, index, key, value, type })
        }
      />
    );
  };

  createCustomField = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key];
    return (
      <WeaCascader.WeaCustomField
        viewAttr={2}
        {...props}
        values={v}
        onChange={value =>
          this.props.onEdit({ record, index, key, value, type })
        }
      />
    );
  };

  createCorlorPicker = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || "";
    return (
      <WeaColorPicker
        viewAttr={2}
        {...props}
        value={v}
        onChange={value =>
          this.props.onEdit({ record, index, key, value, type })
        }
      />
    );
  };

  createCheckbox = (props, type) => {
    const {
      com: { key },
      record,
      index,
      checkProps,
      col
    } = this.props;
    const v = record[key] || "";
    return (
      <WeaCheckbox
        style={{ width: "100%" }}
        viewAttr={checkProps.disabled ? 1 : 2}
        {...props}
        defaultValue={v}
        value={v}
        {...checkProps}
        onChange={value =>
          this.props.onEdit({ record, index, key, value, type, col })
        }
      />
    );
  };

  createRadio = (props, type) => {
    const {
      com: { key },
      record,
      index,
      checkProps,
      col
    } = this.props;
    return (
      <Radio
        {...props}
        {...checkProps}
        onChange={e =>
          this.props.onEdit({
            record,
            index,
            key,
            value: e.target.checked,
            type,
            col
          })
        }
      />
    );
  };

  createSelect = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || "";
    return (
      <WeaSelect
        style={{ width: "100%" }}
        viewAttr={2}
        options={[]}
        {...props}
        defaultValue={v}
        value={v}
        onChange={value =>
          this.props.onEdit({ record, index, key, value, type })
        }
      />
    );
  };

  createTimeRangePicker = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || [];
    return (
      <WeaTimeRangePicker
        style={{ width: "45%" }}
        viewAttr={2}
        {...props}
        defaultValue={v}
        value={v}
        onChange={value =>
          this.props.onEdit({ record, index, key, value, type })
        }
      />
    );
  };

  createTimePicker = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || "";
    return (
      <WeaTimePicker
        style={{ width: "100%" }}
        viewAttr={2}
        {...props}
        defaultValue={v}
        value={v}
        onChange={value =>
          this.props.onEdit({ record, index, key, value, type })
        }
      />
    );
  };

  createDatePicker = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || "";
    return (
      <WeaDatePicker
        style={{ width: "100%" }}
        viewAttr={2}
        {...props}
        defaultValue={v}
        value={v}
        onChange={value =>
          this.props.onEdit({ record, index, key, value, type })
        }
      />
    );
  };

  createTextarea = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || "";
    return (
      <WeaTextarea
        style={{ width: "100%" }}
        viewAttr={2}
        {...props}
        defaultValue={v}
        value={v}
        onChange={value =>
          this.props.onEdit({ record, index, key, value, type })
        }
      />
    );
  };

  createInputNumber = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    let v = record[key] || "";
    if (record[key] === 0) {
      v = 0;
    }
    return (
      <WeaInputNumber
        style={{ width: "100%" }}
        viewAttr={2}
        {...props}
        defaultValue={v}
        value={v}
        onChange={value => {
          this.props.onEdit({ record, index, key, value, type });
        }}
      />
    );
  };

  createInput = (props, type) => {
    const {
      com: { key },
      record,
      index
    } = this.props;
    const v = record[key] || "";
    return (
      <WeaInput
        style={{ width: "100%" }}
        viewAttr={2}
        {...props}
        defaultValue={v}
        value={v}
        onBlur={value => this.props.onEdit({ record, index, key, value, type })}
      />
    );
  };

  createCustom = () => {
    const { com, record, index, text, onEdit } = this.props;
    return com.render(text, record, index, onEdit);
  };

  createText = () => {
    const { com, text } = this.props;
    return (
      <span
        className={`wea-table-edit-html ${com.className || ""}`}
        dangerouslySetInnerHTML={{ __html: formatMultiLang(text) }}
      />
    );
  };

  getWeaComponent() {
    const { com } = this.props;
    const { type, otherParams = {} } = com;
    const t = typeof type === "string" ? type.toUpperCase() : "INPUT";
    // com props
    let props = { ...com };
    delete props.type;
    delete props.key;
    delete props.label;
    delete props.otherParams;
    delete props.error;
    // otherParams props
    props = { ...props, ...otherParams };
    // dispath
    switch (t) {
      case "INPUT":
        return this.createInput(props, t);
      case "INPUTNUMBER":
        return this.createInputNumber(props, t);
      case "TEXTAREA":
        return this.createTextarea(props, t);
      case "DATEPICKER":
        return this.createDatePicker(props, t);
      case "TIMEPICKER":
        return this.createTimePicker(props, t);
      case "TIMERANGEPICKER":
        return this.createTimeRangePicker(props, t);
      case "SELECT":
        return this.createSelect(props, t);
      case "BROWSER":
        return this.createBrowser(props, t);
      case "CHECKBOX":
        return this.createCheckbox(props, t);
      case "SWITCH":
        return this.createCheckbox({ ...props, display: "switch" }, t);
      case "RADIO":
        return this.createRadio(props, t);
      case "CASCADER":
        return this.createCascader(props, t);
      case "CUSTOMFIELD":
        return this.createCustomField(props, t);
      case "COLORPICKER":
        return this.createCorlorPicker(props, t);
      case "CUSTOM":
        return this.createCustom();
      case "TEXT":
        return this.createText();
      default:
        return null;
    }
  }

  // wrap WeaError
  wrapWeaComponent = () => {
    const {
      com: { key, isTreeNode, viewAttr },
      len,
      rowKey,
      index,
      validate: { validateResult },
      record,
      doAdd,
      lastTreeNode,
      operationKey,
      onRowAdd
    } = this.props;
    const error =
      validateResult && validateResult[key] ? validateResult[key][0] : "";
    const dotIndex = record[rowKey].toString().split(".").length - 1;
    let paddingLeft = 20 * dotIndex,
      left = 20 * (dotIndex - 1);
    paddingLeft < 0 && (paddingLeft = 0);
    left < 0 && (left = 0);
    const com = isTreeNode ? (
      <div style={{ position: "relative", paddingLeft: paddingLeft }}>
        {dotIndex !== 0 && (
          <i
            className={`${
              lastTreeNode ? "icon-coms-line-2" : "icon-coms-line-1"
            }`}
            style={{
              fontSize: 18,
              color: "#979797",
              position: "absolute",
              left,
              top: 4
            }}
          />
        )}
        <WeaError
          ref={`error_${record[rowKey]}_${key}`}
          error={error}
          style={{ paddingRight: 20, width: "100%" }}
          tipPosition={len === index + 1 ? "top" : "bottom"}
        >
          {this.getWeaComponent()}
        </WeaError>
        {record[operationKey] && (
          <i
            className="icon-coms-Enlarge"
            style={{
              position: "absolute",
              fontSize: 15,
              color: "#979797",
              top: viewAttr === 1 ? 4 : 7,
              right: -8,
              cursor: "pointer"
            }}
            onClick={() => {
              isFunction(doAdd) && doAdd(record[rowKey]);
              isFunction(onRowAdd) && onRowAdd(record, index);
            }}
          />
        )}
      </div>
    ) : (
      <WeaError
        ref={`error_${record[rowKey]}_${key}`}
        error={error}
        tipPosition={len === index + 1 ? "top" : "bottom"}
      >
        {this.getWeaComponent()}
      </WeaError>
    );
    return com;
  };

  // tableCellProps
  wrapReactComponent = () => {
    const { com, record, index, text, onEdit } = this.props;
    return cloneElement(com, {
      tableCellProps: { record, index, text, onEdit }
    });
  };

  render() {
    const { com, rowKey, record } = this.props;
    if (isValidElement(com)) {
      return this.wrapReactComponent();
    }
    const { label = "", key, type, hasHiddenField } = com;
    // hidden field
    const hiddrenField = (
      <input
        id={`${key}_${record[rowKey]}`}
        type="hidden"
        value={record[key]}
      />
    );
    if (typeof type === "string" && type.toUpperCase() === "HIDDENFIELD") {
      return hiddrenField;
    }
    return (
      <span>
        {label ? <span style={{ marginLeft: 5 }}>{label}</span> : null}
        {this.wrapWeaComponent()}
        {hasHiddenField ? hiddrenField : null}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-table-editable/TableCell.js